<template>
  <div class="col-lg-9 c-content-main">
    <div class="tile">
      <h3 class="tile-title is-line">{{ $t('znsTemplateInfo') }}</h3>
      <div class="tile-body">
        <div class="c-config-content">
          <div v-if="firstLoading">
            <skeleton-loading>
              <row>
                <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
              </row>
              <row>
                <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
              </row>
            </skeleton-loading>
          </div>
          <div v-else>
            <div class="c-template-table table-responsive c-role-table">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>{{ $t('name') }}</th>
                  <th>{{ $t('zaloOA') }}</th>
                  <th class="text-center">{{ $t('status') }}</th>
                </tr>
                </thead>
                <tbody v-if="listLoading" class="text-center text-primary">
                <tr>
                  <th colspan="3">
                    <b-spinner></b-spinner>
                  </th>
                </tr>
                </tbody>
                <tbody v-if="!listLoading && !itemCount" class="text-center text-gray-999">
                <tr>
                  <th colspan="3">
                    {{ $t('noResultsText') }}
                  </th>
                </tr>
                </tbody>
                <tbody v-if="!listLoading && itemCount">
                <tr v-for="item in items" :key="item._id">
                  <td>{{ item.name }}</td>
                  <td>
                    <span v-if="item.oa">{{ item.oa.name }} ({{ item.oa.oaId }})</span>
                  </td>
                  <td class="text-center">
                    <div>
                      <label v-if="item.active" class="badge badge-success">{{ $t('activated') }}</label>
                      <label v-else class="badge badge-danger">{{ $t('deactivated') }}</label>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <b-modal v-model="showForm" :title="$t('zns')" no-close-on-backdrop no-enforce-focus>
              <p>{{ $t('emailSubject') }}</p>
              <form-input :model="formModel" :errors="formErrors" attribute="title"
                          :placeholder="$t('znsTitle')"></form-input>
              <p>{{ $t('content') }}</p>
              <form-textarea :model="formModel" attribute="content" :placeholder="$t('znsContent')"
                             :errors="formErrors"></form-textarea>
              <label>{{ $t('numberOfCharacter') }}:
                <b-spinner v-if="countLoading" small></b-spinner>
                <span v-else
                      :class="characterCount>characterLimit ? 'text-danger' : ''">{{ characterCount }}</span>/{{ characterLimit }}
              </label>
              <p><i :class="contentTbl ? 'fa fa-times-circle' : 'fa fa-plus-circle'"
                    @click="contentTbl = !contentTbl"></i> &nbsp;{{ $t('notRequiredInfo') }}</p>
              <div v-if="contentTbl">
                <table class="table table-hover">
                  <thead>
                  <tr>
                    <td>{{ $t('fieldName') }}</td>
                  </tr>
                  </thead>
                  <tr>
                    <td>
                      <form-input :model="formModel" :errors="formErrors" :attribute="'fieldName1'"
                                  :placeholder="$t('additionalInfo')"></form-input>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <form-input :model="formModel" :errors="formErrors" attribute="fieldName2"
                                  :placeholder="$t('additionalInfo')"></form-input>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <form-input :model="formModel" :errors="formErrors" attribute="fieldName3"
                                  :placeholder="$t('additionalInfo')"></form-input>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <form-input :model="formModel" :errors="formErrors" attribute="fieldName4"
                                  :placeholder="$t('additionalInfo')"></form-input>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <form-input :model="formModel" :errors="formErrors" attribute="fieldName5"
                                  :placeholder="$t('additionalInfo')"></form-input>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <form-input :model="formModel" :errors="formErrors" attribute="fieldName6"
                                  :placeholder="$t('additionalInfo')"></form-input>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <form-input :model="formModel" :errors="formErrors" attribute="fieldName7"
                                  :placeholder="$t('additionalInfo')"></form-input>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <form-input :model="formModel" :errors="formErrors" attribute="fieldName8"
                                  :placeholder="$t('additionalInfo')"></form-input>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <form-input :model="formModel" :errors="formErrors" attribute="fieldName9"
                                  :placeholder="$t('additionalInfo')"></form-input>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <form-input :model="formModel" :errors="formErrors" attribute="fieldName10"
                                  :placeholder="$t('additionalInfo')"></form-input>
                    </td>
                  </tr>
                </table>
                <p>CTA 1</p>
                <form-input :model="formModel" :errors="formErrors" attribute="ctaOne"
                            :placeholder="$t('znsTitle')"></form-input>
                <p>CTA 2</p>
                <form-input :model="formModel" :errors="formErrors" attribute="ctaTwo"
                            :placeholder="$t('znsTitle')"></form-input>
              </div>
              <div class="alert alert-warning" v-html="$t('smsTemplateNote')"></div>
              <template v-slot:modal-footer>
                <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('cancel') }}
                </b-button>
                <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="save">
                  <b-spinner v-if="saveLoading" small></b-spinner>
                  {{ $t('save') }}
                </b-button>
              </template>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import list from '../../../../mixins/List';
import crud from '../../../../mixins/CRUD';

export default {
  mixins: [list, crud],
  components: {},
  data: function () {
    return {
      service: '/zns-template',
      showForm: false,
      contentTbl: false,
      characterCount: 0,
      characterLimit: 2000,
      countLoading: false
    }
  },
  mounted() {
    this.$bus.$on('reloadSMSBrandNames', this.load)
  },
  methods: {
    copy(str) {
      this.$copyText(str).then(() => {
        this.$swal({
          text: this.$t('idCopied'),
          icon: 'success',
          toast: true,
          position: 'top-end',
          timer: 5000,
        });
      }, () => {
        this.$swal({
          title: this.$t('error'),
          text: this.$t('copyFailed'),
          icon: 'error'
        });
      })
    },
    getStatus(item) {
      if (!item.submitTime) {
        return this.$t('draft')
      } else if (item.approveTime) {
        return this.$t('approved')
      } else if (item.denyTime) {
        return this.$t('denied');
      } else {
        return this.$t('waiting');
      }
    },
    submit: function (id) {
      this.$swal({
        title: this.$t('submitZNSTemplateConfirm'),
        text: this.$t('submitZNSTemplateAlert'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.updateLoading = true;
          this.$service.put(this.service + '/submit/' + id).then(response => {
            if (response.data && !response.data.msg) {
              this.$swal({
                title: this.$t('success'),
                text: this.$t('znsTemplateSubmitted'),
                icon: 'success',
                toast: true,
                position: 'top-end',
                timer: 5000,
              });
              this.load();
            } else {
              this.$swal({
                title: this.$t('error'),
                text: response.data.msg,
                icon: 'error',
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            this.updateLoading = false;
          });
        }
      });
    }
  },
  watch: {
    "formModel.content": {
      handler() {
        if (this.formModel && this.formModel.content) {
          this.countLoading = true;
          let paramCount = this.$utils.getMatchesParam(this.formModel.content);

          let paramLength = 0;
          if (paramCount && paramCount.length > 0) {
            paramCount.forEach(elm => {
              paramLength += (elm.value - elm.key.length);
            });
            this.characterCount = this.formModel.content.length + paramLength;
            this.paramTemplate = paramCount;
            this.msgLength = this.characterCount;
            this.countLoading = false
          } else {
            this.countLoading = false;
            this.characterCount = this.formModel.content.length;
          }
        } else {
          this.countLoading = false;
          this.characterCount = 0;
        }
      }
    }
  },
  beforeDestroy() {
    this.$bus.$off('reloadSMSBrandNames')
  }
}
</script>